/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Proc_HardenInputs */

const en_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const ar_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التقوية`)
};

const bn_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হার্ডেন`)
};

const de_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const es_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const fr_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const pt_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const zh_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const tr_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const ru_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

const pl_proc_harden = /** @type {(inputs: Proc_HardenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HARDEN`)
};

/**
* | output |
* | --- |
* | "HARDEN" |
*
* @param {Proc_HardenInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const proc_harden = /** @type {((inputs?: Proc_HardenInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Proc_HardenInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_proc_harden(inputs)
	if (locale === "bn") return bn_proc_harden(inputs)
	if (locale === "de") return de_proc_harden(inputs)
	if (locale === "es") return es_proc_harden(inputs)
	if (locale === "fr") return fr_proc_harden(inputs)
	if (locale === "pt") return pt_proc_harden(inputs)
	if (locale === "zh") return zh_proc_harden(inputs)
	if (locale === "tr") return tr_proc_harden(inputs)
	if (locale === "ru") return ru_proc_harden(inputs)
	if (locale === "pl") return pl_proc_harden(inputs)
	return en_proc_harden(inputs)
});